import React from 'react';
import { Formik } from 'formik';
import { Box, Card, FormControl, FormGroup, IconButton, InputLabel } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { ArrowBack } from '@material-ui/icons';
import { CheckboxField, InputField } from '../../../../components/forms/fields';
import FormWrapper from '../../../../components/forms/FormWrapper';
import { sanitizeFormValues } from '../../../../utils';
import { FormSubmitType } from '../../../../types';
import { Venue } from '../../../../server-types';
import { Typography } from '../../../../ui-kit';
import { newWarehouseValidationScheme } from './validation';


type OnSubmit = FormSubmitType<WarehouseFormValues>;

interface WarehouseFormProps {
    onSubmit: OnSubmit;
    onClose: () => void;
    venues: Array<Pick<Venue, 'id' | 'name'>>;
    initialValues?: WarehouseFormValues;
    currentVenueId: string;
    buttonText: string;
    dialogName: string;
}

export interface WarehouseFormValues {
    name: string;
    venueIds: string[];
}

const WarehouseForm = ({
    venues,
    onSubmit,
    initialValues,
    currentVenueId,
    onClose,
    buttonText,
    dialogName,
}: WarehouseFormProps) => {
    const { t } = useTranslation();
    const defaultValues: WarehouseFormValues = {
        name: '',
        venueIds: [currentVenueId],
    };

    const handleSubmit = async (values: WarehouseFormValues) => {
        const finalValues = sanitizeFormValues(values);
        return onSubmit(finalValues);
    };

    return (
        <Card style={{ height: '100%' }}>
            <Box px={3} py={2}>
                <IconButton edge="start" color="inherit" onClick={onClose} aria-label="close">
                    <ArrowBack />
                </IconButton>
                <Box mb={2} />
                <Typography variant='h6' component='h1'>{dialogName}</Typography>
                <Formik
                    initialValues={{ ...defaultValues, ...initialValues }}
                    validationSchema={newWarehouseValidationScheme}
                    onSubmit={handleSubmit}
                >
                    {formikProps => (
                        <FormWrapper submitText={buttonText} isSubmitting={formikProps.isSubmitting} isDialogView>
                            <Box my={2} width="100%" display="flex" flexDirection="column">
                                <InputField<WarehouseFormValues> name="name" label={t('Name')} formikProps={formikProps} required />
                                <InputLabel>{t('Available in venues')}</InputLabel>
                                <FormControl fullWidth variant="outlined" size='small'>
                                    <FormGroup>
                                        {venues.map(({ id: venueId, name }) => {
                                            return (
                                                <CheckboxField
                                                    key={venueId}
                                                    formikProps={formikProps}
                                                    name="venueIds"
                                                    defaultChecked={currentVenueId === venueId}
                                                    value={venueId}
                                                    label={name}
                                                />
                                            );
                                        })}
                                    </FormGroup>
                                </FormControl>
                            </Box>
                        </FormWrapper>
                    )}
                </Formik>
            </Box>
        </Card>
    );
};

export default WarehouseForm;
